module.exports = __webpack_public_path__ + "img/icon-web-bd4ea337.svg";